function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  id: "Path_327",
  "data-name": "Path 327",
  d: "M608.3,410.679v11.205a28.43,28.43,0,0,0-.451,3.753A129.741,129.741,0,0,1,604.67,452.4a134.17,134.17,0,0,1-36.442,68c-13.6,13.726-29.4,24.383-46.609,33.041-20.784,10.438-42.694,17.616-65.252,23.013a503.278,503.278,0,0,1-55.986,9.781c-15.039,1.836-30.133,3.233-45.229,3.89-14.982.685-29.936.932-44.89,1.37-.76.027-1.521.192-2.281.274h-7.66c-1.1-.082-2.2-.247-3.3-.274-19.038-.192-38.1-.822-57.113-2.192a598.275,598.275,0,0,1-68.8-8.767c-21.6-4.164-42.778-9.753-63.28-17.808-19.009-7.479-36.949-16.876-53.086-29.561C31.57,514.924,15.236,491.966,6.9,463.5A158.261,158.261,0,0,1,.958,429.693c-.169-2.438-.62-4.849-.958-7.288V410.679a45.41,45.41,0,0,0,.76-4.767,282.135,282.135,0,0,1,8.73-54.794A467.093,467.093,0,0,1,34.5,279.777c14.672-33.726,32.049-66.054,51-97.56,18.362-30.493,38.244-59.917,61.056-87.286,15.461-18.52,32.1-35.89,50.861-51.123,15.039-12.246,31.147-22.822,48.918-30.685A146.794,146.794,0,0,1,291.985.877C294.6.63,297.2.3,299.814,0H309a21.686,21.686,0,0,0,2.253.411c4.478.493,8.984.767,13.433,1.452,17.77,2.658,34.386,8.74,50.185,17.205,20.305,10.876,38.273,24.959,54.916,40.794a438.392,438.392,0,0,1,49.115,55.89c34.414,46.054,63.337,95.4,87.951,147.286,13.18,27.78,24.3,56.328,31.992,86.108,4.985,19.205,8.7,38.63,9.04,58.547A26.365,26.365,0,0,0,608.3,410.679Z",
  transform: "translate(0 0)",
  fill: "none",
  clipRule: "evenodd"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_160",
  "data-name": "Group 160",
  transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 157.44)"
}, React.createElement("g", {
  id: "Group_159",
  "data-name": "Group 159",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, React.createElement("g", {
  id: "Group_158",
  "data-name": "Group 158",
  transform: "translate(0 0)"
}, React.createElement("path", {
  id: "Path_326",
  "data-name": "Path 326",
  d: "M0,0H608.3V591.773H0Z",
  fill: "rgba(250,217,97,0.35)"
}))));

var SvgProfileEditDecor = function SvgProfileEditDecor(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 740.738,
    height: 729.049,
    viewBox: "0 0 740.738 729.049",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProfileEditDecor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-edit-decor.5c0be712.svg";
export { ForwardRef as ReactComponent };